"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ReflectRight: ['reflect-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,8a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V9A1,1,0,0,0,12,8Z', 'M2.061,8.646A1.175,1.175,0,0,0,0,9.5v13a1.175,1.175,0,0,0,2.061.854l6.293-6.293a1.5,1.5,0,0,0,0-2.122Zm.366,11.513A.25.25,0,0,1,2,19.982V12.018a.25.25,0,0,1,.427-.177l3.982,3.982a.25.25,0,0,1,0,.354Z', 'M21.939,8.646l-6.293,6.293a1.5,1.5,0,0,0,0,2.122l6.293,6.293A1.174,1.174,0,0,0,24,22.5V9.5A1.173,1.173,0,0,0,21.939,8.646Z', 'M18.4,7.447l1.614-3.223A1,1,0,0,0,18.893,2.8L17.5,3.117a.245.245,0,0,1-.254-.1A7,7,0,0,0,4.5,7a1,1,0,0,0,2,0,5.006,5.006,0,0,1,5-5,4.948,4.948,0,0,1,3.364,1.326.243.243,0,0,1-.11.415l-.762.173a1,1,0,0,0-.318,1.817L16.96,7.842A1.024,1.024,0,0,0,18.4,7.447Z']],
  ReflectLeft: ['reflect-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,8a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V9A1,1,0,0,0,12,8Z', 'M21.939,8.646l-6.293,6.293a1.5,1.5,0,0,0,0,2.122l6.293,6.293A1.174,1.174,0,0,0,24,22.5V9.5A1.173,1.173,0,0,0,21.939,8.646ZM22,19.982a.25.25,0,0,1-.427.177l-3.982-3.982a.25.25,0,0,1,0-.354l3.982-3.982a.25.25,0,0,1,.427.177Z', 'M2.061,8.646A1.173,1.173,0,0,0,0,9.5v13a1.175,1.175,0,0,0,2.061.854l6.293-6.293a1.5,1.5,0,0,0,0-2.122Z', 'M10.008,3.914l-.761-.173a.243.243,0,0,1-.111-.415A4.948,4.948,0,0,1,12.5,2a5.006,5.006,0,0,1,5,5,1,1,0,0,0,2,0A7,7,0,0,0,6.75,3.018a.245.245,0,0,1-.254.1L5.107,2.8A1,1,0,0,0,3.991,4.224L5.605,7.447a1.023,1.023,0,0,0,1.435.395l3.286-2.111A1,1,0,0,0,10.008,3.914Z']],
  FlipLeft: ['flip-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1,4A1,1,0,0,0,2,3V2.5A.5.5,0,0,1,2.5,2H3A1,1,0,0,0,3,0H2A2,2,0,0,0,0,2V3A1,1,0,0,0,1,4Z', 'M6.5,2H8A1,1,0,0,0,8,0H6.5a1,1,0,0,0,0,2Z', 'M3,22H2.5a.5.5,0,0,1-.5-.5V21a1,1,0,0,0-2,0v1a2,2,0,0,0,2,2H3a1,1,0,0,0,0-2Z', 'M8,22H6.5a1,1,0,0,0,0,2H8a1,1,0,0,0,0-2Z', 'M1,13.5a1,1,0,0,0,1-1v-1a1,1,0,0,0-2,0v1A1,1,0,0,0,1,13.5Z', 'M1,8.5a1,1,0,0,0,1-1v-1a1,1,0,0,0-2,0v1A1,1,0,0,0,1,8.5Z', 'M1,18.5a1,1,0,0,0,1-1v-1a1,1,0,0,0-2,0v1A1,1,0,0,0,1,18.5Z', 'M12,13a5.822,5.822,0,0,0-.784.055A.25.25,0,0,0,11,13.3V23a1,1,0,0,0,2,0V13.273a.249.249,0,0,0-.234-.249Q12.4,13,12,13Z', 'M12.734,8.028A.25.25,0,0,0,13,7.779V1a1,1,0,0,0-2,0V7.781a.25.25,0,0,0,.269.25C11.508,8.012,11.75,8,12,8S12.5,8.014,12.734,8.028Z', 'M8.371,12.811a.251.251,0,0,1,.059-.4A7.472,7.472,0,0,1,12,11.5a9.2,9.2,0,0,1,6.228,2,1,1,0,1,0,1.308-1.512A11.151,11.151,0,0,0,12,9.5a9.541,9.541,0,0,0-5.145,1.518.252.252,0,0,1-.311-.034L5.53,9.97a.75.75,0,0,0-1.28.53v3.251c0,.828.3,1,1.007,1H8.5a.751.751,0,0,0,.53-1.28Z', 'M24,2a2,2,0,0,0-2-2H15.5a1,1,0,0,0,0,2h6a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5H16a1,1,0,0,0,0,2h6a2,2,0,0,0,2-2Z']],
  FlipRight: ['flip-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,2a2,2,0,0,0-2-2H21a1,1,0,0,0,0,2h.5a.5.5,0,0,1,.5.5V3a1,1,0,0,0,2,0Z', 'M15,1a1,1,0,0,0,1,1h1.5a1,1,0,0,0,0-2H16A1,1,0,0,0,15,1Z', 'M23,20a1,1,0,0,0-1,1v.5a.5.5,0,0,1-.5.5H21a1,1,0,0,0,0,2h1a2,2,0,0,0,2-2V21A1,1,0,0,0,23,20Z', 'M18.5,23a1,1,0,0,0-1-1H16a1,1,0,0,0,0,2h1.5A1,1,0,0,0,18.5,23Z', 'M23,10.5a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,23,10.5Z', 'M23,5.5a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,23,5.5Z', 'M23,15.5a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0v-1A1,1,0,0,0,23,15.5Z', 'M12.731,8.031A.25.25,0,0,0,13,7.781V1a1,1,0,0,0-2,0V7.779a.25.25,0,0,0,.079.182.248.248,0,0,0,.187.067C11.505,8.014,11.745,8,12,8S12.492,8.012,12.731,8.031Z', 'M11.234,13.024a.249.249,0,0,0-.234.249V23a1,1,0,0,0,2,0V13.3a.25.25,0,0,0-.216-.248A5.822,5.822,0,0,0,12,13Q11.6,13,11.234,13.024Z', 'M19.75,10.5a.755.755,0,0,0-1.356-.454h0l-.938.938a.252.252,0,0,1-.311.034A9.541,9.541,0,0,0,12,9.5a11.151,11.151,0,0,0-7.536,2.486A1,1,0,1,0,5.772,13.5,9.2,9.2,0,0,1,12,11.5a7.472,7.472,0,0,1,3.57.914.251.251,0,0,1,.059.4l-.659.659a.751.751,0,0,0,.53,1.28h3.243c.7,0,1.007-.17,1.007-1Z', 'M9,23a1,1,0,0,0-1-1H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h6a1,1,0,0,0,0-2H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H8A1,1,0,0,0,9,23Z']]
};
exports["default"] = _default;